import React from 'react'
import styled from '@emotion/styled'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface MenuGenerationProfileProps {
  markdown: string | null
  isLoading: boolean
}

const MenuGenerationProfile: React.FC<MenuGenerationProfileProps> = ({
  markdown,
  isLoading,
}) => {
  return (
    <Container>
      <Header>Client Profile</Header>
      <Content>
        {isLoading ? (
          <EmptyState>Loading profile...</EmptyState>
        ) : markdown ? (
          <MarkdownWrapper>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {markdown}
            </ReactMarkdown>
          </MarkdownWrapper>
        ) : (
          <EmptyState>
            No client profile found. You can ask the assistant to create one.
          </EmptyState>
        )}
      </Content>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const Header = styled.div`
  font-size: 14px;
  font-weight: 600;
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  color: #333;
`

const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
`

const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  color: #888;
  font-size: 13px;
  text-align: center;
`

const MarkdownWrapper = styled.div`
  font-size: 13px;
  line-height: 1.6;
  color: #333;

  h1,
  h2,
  h3,
  h4 {
    margin-top: 16px;
    margin-bottom: 8px;
    &:first-of-type {
      margin-top: 0;
    }
  }

  h1 {
    font-size: 18px;
    font-weight: bold;
  }
  h2 {
    font-size: 16px;
    font-weight: bold;
  }
  h3 {
    font-size: 14px;
    font-weight: bold;
  }

  p {
    margin: 8px 0;
  }

  ul,
  ol {
    padding-left: 20px;
    margin: 8px 0;
  }

  li {
    margin: 4px 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 8px 0;
    font-size: 12px;
  }

  th,
  td {
    border: 1px solid #ddd;
    padding: 6px 8px;
    text-align: left;
  }

  th {
    background: #f5f5f5;
    font-weight: 600;
  }

  code {
    background: #f5f5f5;
    padding: 2px 4px;
    border-radius: 3px;
    font-size: 12px;
  }

  hr {
    border: none;
    border-top: 1px solid #e0e0e0;
    margin: 16px 0;
  }
`

export default MenuGenerationProfile
